export default __webpack_public_path__ + "static/media/SAS Alert Tone 22.a9c6db10.mp3";